export default "__VITE_ASSET__CJaNby2g__"